import { useState, useEffect } from 'react'
import Stack from '@mui/material/Stack'
import TextField from '@mui/material/TextField'

function FilterRange({ filter, query, setQuery }) {
  const [range, setRange] = useState({
    min: query[filter.name]?.min || '',
    max: query[filter.name]?.max || '',
  })

  useEffect(() => {
    if (!range.min && !range.max) {
      setQuery((query) => ({
        ...query,
        [filter.name]: undefined,
      }))
      return
    }

    setQuery((query) => ({ ...query, [filter.name]: range }))
  }, [range, filter, setQuery])

  const handleMinInputChange = (e) => {
    if (!e.target.value) {
      setRange({ ...range, min: '' })

      return
    }

    let value = parseInt(e.target.value, 10)

    if (value >= +filter.maxValue) value = filter.maxValue
    if (range.max !== '' && value >= +range.max) value = range.max
    if (value < +filter.minValue) value = filter.minValue

    setRange({ ...range, min: value })
  }

  const handleMaxInputChange = (e) => {
    if (!e.target.value) {
      setRange({ ...range, max: '' })

      return
    }

    let value = parseInt(e.target.value, 10)

    if (value > +filter.maxValue) value = filter.maxValue
    if (range.min !== '' && value <= +range.min) value = range.min
    if (value < +filter.minValue) value = filter.minValue

    setRange({ ...range, max: value })
  }

  return (
    <Stack direction="row" spacing={0.8} sx={{ alignItems: 'center' }}>
      <Stack
        direction="row"
        spacing={0.8}
        sx={{ flex: 1, alignItems: 'center' }}
      >
        <TextField
          type="number"
          placeholder={
            filter.minPlaceholder ||
            (filter.isPercentValue ? `${filter.minValue}%` : filter.minValue)
          }
          variant="outlined"
          size="small"
          value={range.min}
          onChange={handleMinInputChange}
          sx={{ flex: 1, borderRadius: '0.8rem' }}
        />
        <span>—</span>
        <TextField
          type="number"
          placeholder={
            filter.maxPlaceholder ||
            (filter.isPercentValue ? `${filter.maxValue}%` : filter.maxValue)
          }
          variant="outlined"
          size="small"
          value={range.max}
          onChange={handleMaxInputChange}
          sx={{ flex: 1, borderRadius: '0.8rem' }}
        />
      </Stack>
    </Stack>
  )
}

export default FilterRange
